module.exports = __webpack_public_path__ + "static/images/th.3tzTXp2.svg";